import BoardItem from './BoardItem';

export default BoardItem;
